import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Link from '@mui/material/Link';
import Zoom from '@mui/material/Zoom';
import { toast } from 'react-toastify';
import { httpGet, httpPost, httpPut, httpDelete } from '../../HttpRequestHandling/httpRequestHandler';
//import TaxMaps from './TaxMaps';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { GridActionsCellItem } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Close';
import { GridRowModes } from '@mui/x-data-grid';
import RemoveIcon from '@mui/icons-material/Remove';
import Checkbox from '@mui/material/Checkbox';
import { Check } from '@mui/icons-material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import AddResources from './AddResources';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom in={true} ref={ref} {...props} />;
});

export default function CLResources(props) {
    //const [openAddBoxDialog, setOpenAddBoxDialog] = useState(false);
    const [data, setData] = React.useState([]);
    //const [openTaxMapsDialog, setOpenTaxMapsDialog] = React.useState(false);
    const [openAddBoxDialog, setopenAddBoxDialog] = React.useState(false);
    const [lastUpdated, setLastUpdated] = React.useState("");
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [currentEditRowId, setCurrentEditRowId] = React.useState({ userRolesList: [] });
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
    const [companyCode, setCompanyCode] = React.useState(null);
    const [selectedTaxTypeCode, setSelectedTaxTypeCode] = React.useState(null);
    const [isAdding, setIsAdding] = React.useState(null);
    const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
    const [deleteRowData, setDeleteRowData] = React.useState(null);
    const rolesData = ['Admin', 'Editor', 'Viewer', 'Contributor']; // Dummy roles data


    const handleAddBoxClick = () => {
        setOpenAddBoxDialog(true);
    };

    const handleCloseAddBoxDialog = () => {
        setOpenAddBoxDialog(false);
    };

    //const getAddBoxButton = () => (
    //    <IconButton onClick={handleAddBoxClick}>
    //        <AddResources />
    //    </IconButton>
    //);

    React.useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const companyCode = userInfo ? userInfo.companyCode : null;
        setCompanyCode(companyCode);
        fetchTaxes();
    }, []);

    //const fetchTaxes = React.useCallback(() => {

    //    props.inProgress(true);

    //    httpGet('/api/setup/taxes')
    //        .then((response) => {
    //            const data = response.data;
    //            const records = (data.records || []).map((e, i) => ({ ...e, rowId: i }));
    //            const localDateString = data.lastUpdated == null ? "" : new Date(data.lastUpdated).toLocaleString();
    //            setData(records);
    //            setLastUpdated(localDateString);
    //            props.inProgress(false);
    //        })
    //        .catch((error) => {
    //            props.inProgress(false);

    //            toast.error(`An error occurred while fetching the records: ${error.message}`);
    //        });
    //}, [props]);

    const fetchTaxes = React.useCallback(() => {

        props.inProgress(true);

        httpGet('/api/userroles/')
            .then((response) => {
                var userRolesList = response.data;

                props.inProgress(false);

                setState((prev) => ({ ...prev, userRolesList: userRolesList }));
            })
            .catch((error) => {
                props.inProgress(false);

                toast.error('An error occurred while fetching the records');
                console.error('There was an error!', error);
            });
    }, [props]);

    const isRecordValid = (data, existingData) => {
        let isValid = true;
        let message = "";
        const newTaxCode = data.taxCode?.trim().toLowerCase();
        const newTaxTypeCode = data.taxTypeCode?.trim().toLowerCase();
        const taxExists = existingData.some(row =>
            row.taxCode.trim().toLowerCase() === newTaxCode &&
            row.taxTypeCode.trim().toLowerCase() === newTaxTypeCode &&
            row.rowId !== data.rowId
        );

        if (taxExists) {
            toast.error('This tax code and tax type code combination already exists');
            return false;
        }
        if (!data.taxCode || data.taxCode.trim().length === 0) {
            message += "Tax Code, ";
        }
        if (!data.otherTaxAmt || isNaN(data.otherTaxAmt)) {
            message += "Tax Amount, ";
        }
        if (!data.taxTypeCode || data.taxTypeCode.trim().length === 0) {
            message += "Tax Type Code, ";
        }
        if (message.length > 0) {
            message = message.slice(0, -2);
            toast.error(`Please provide ${message}`);
            isValid = false;
        }
        return isValid;
    };


    const handleAddClick = React.useCallback(() => {
        const id = ([...data]?.sort((a, b) => b.rowId - a.rowId)[0]?.rowId + 1) || 1;
        let model = {
            rowId: id,
            isNew: true
        };
        setData((prevData) => [model, ...prevData]);
        setCurrentEditRowId(id);
        setRowModesModel((prevModel) => ({ ...prevModel, [id]: { mode: GridRowModes.Edit, fieldToFocus: 'taxCode' } }));
        setIsButtonDisabled(true);
        setIsAdding(true);
    }, [data, currentEditRowId]);

    const getUserRoleName = React.useCallback((apadUserRolesResource) => {
        var assignedUserRolesResources = "";

        if (state.userRolesList.length > 0 && apadUserRolesResource && apadUserRolesResource.length > 0) {
            assignedUserRolesResources = state.userRolesList.find(ur => ur.userRoleId === apadUserRolesResource[0].userRoleId).userRoleName + (apadUserRolesResource.length > 1 ? "..." : "");
        }

        return assignedUserRolesResources;
    }, [data, currentEditRowId]);

    // Function to get the selected roles as a comma-separated string
    const getUserRoleNameList_dummy = (selectedRoles) => {
        if (selectedRoles.length === 0) return 'No roles selected';
        return selectedRoles.join(', ');
    };

    // Function to get a single role (if needed for a different logic)
    const getUserRoleName_dummy = (selectedRoles) => {
        if (selectedRoles.length > 0) return selectedRoles[0]; // Display first role or any other logic
        return 'No role';
    };

    // Function to handle role selection and updating the state
    const handleRoleSelectionChange = (e, role, selectedRoles, setSelectedRoles) => {
        const isChecked = e.target.checked;
        let updatedRoles = [...selectedRoles];

        if (isChecked) {
            updatedRoles.push(role);
        } else {
            updatedRoles = updatedRoles.filter((r) => r !== role);
        }

        setSelectedRoles(updatedRoles); // Update selected roles in state
    };

    const getUserRoleNameList = React.useCallback((apadUserRolesResource) => {
        return (<ul key={2} style={{ margin: 0, pading: 0, listStyle: 'none' }}> {(apadUserRolesResource)
            .map((e, ei) => {
                let rolename = state.userRolesList.find(ur => ur.userRoleId === e.userRoleId)?.userRoleName;
                return (rolename && <li key={ei}>{rolename}</li>) || <></>
            })}</ul>)
    }, [data, currentEditRowId]);

    const handleSaveClick = (newData) => {
        setRowModesModel({ ...rowModesModel, [newData.rowId]: { mode: GridRowModes.View } });
    };

    const AddButtonClick = (event) => {
        event.preventDefault();
        setopenAddBoxDialog(true);
        setSelectedTaxTypeCode(event.target.dataset.taxCode);

        //this.setState({ openLevel3Dialog: true, selectedLevel2Key: event.target.dataset.level2key });

    };

    const saveTaxes = React.useCallback((newdata, oldData) => {
        let rowdata = structuredClone(newdata);
        let endpoint = "/api/setup/savetax";

        rowdata.companyCode = parseInt(companyCode);

        props.inProgress(true);

        httpPost(endpoint, rowdata)
            .then((response) => {
                props.inProgress(false);
                newdata.isNew ? toast.success('Added Successfully') : toast.success('Updated Successfully');
                fetchTaxes();
                setIsButtonDisabled(false);
            })
            .catch((error) => {
                if (newdata?.isNew) {
                    setData((prev) => prev.filter(e => e.rowId !== newdata.rowId));
                } else {
                    setData((prev) => prev.map(e => e.rowId === newdata.rowId ? oldData : e));
                }
                props.inProgress(false);
                toast.error(<div>Taxes Update Failed<br />{error.response.data}</div>);
                setIsButtonDisabled(false);
            });
    }, [companyCode, fetchTaxes, props]);

    const handleDeleteClick = React.useCallback((rowData) => {
        setDeleteRowData(rowData);
        setOpenDeleteConfirmation(true);
    }, []);

    const closeDeleteDialog = React.useCallback(() => {
        setOpenDeleteConfirmation(false);
        setDeleteRowData(null);
    }, []);

    const deleteTaxes = React.useCallback(() => {
        props.inProgress(true);
        const data = deleteRowData;
        const url = `/api/setup/deletetax?taxCode=${encodeURIComponent(data.taxCode)}&taxTypeCode=${encodeURIComponent(data.taxTypeCode)}`;

        setOpenDeleteConfirmation(false);
        setDeleteRowData(null);

        httpDelete(url)
            .then((response) => {
                props.inProgress(false);
                toast.success('Deleted Successfully');
                fetchTaxes();
            })
            .catch((error) => {
                props.inProgress(false);
                if (error.response.data.includes("Cannot delete, record being referenced by other entities.")) {
                    toast.error("Cannot delete, record being referenced by other entities.");
                } else {
                    toast.error(<div>Delete Failed<br />{error.response.data}</div>);
                }
            });
    }, [deleteRowData, fetchTaxes]);


    const processRowUpdate = React.useCallback((newrow, oldrow) => {
        let _newrow = structuredClone(newrow);
        if (!isRecordValid(_newrow, data)) {
            setRowModesModel({ ...rowModesModel, [_newrow.rowId]: { mode: GridRowModes.Edit } });
            throw new Error('');
        }
        setCurrentEditRowId(null);
        saveTaxes(_newrow, oldrow);
        return newrow;
    }, [saveTaxes]);

    const handleCancelClick = React.useCallback((id) => {
        setRowModesModel((prevModel) => ({
            ...prevModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setCurrentEditRowId(null);
        setIsButtonDisabled(false);
        setIsAdding(false);
        setData((prevData) => prevData.filter((row) => !(row.rowId === id && row.isNew)));
    }, []);

    const handleEditClick = React.useCallback((id) => {
        setCurrentEditRowId(id);
        setIsButtonDisabled(true);
        editable: false;
        setIsAdding(false);
        setRowModesModel((prevModel) => ({ ...prevModel, [id]: { mode: GridRowModes.Edit } }));
    }, []);

    const editTaxMaps_clickHandler = (event) => {
        event.preventDefault();
        setOpenAddBoxDialog(true);
        setSelectedTaxTypeCode('GST_5');
    };

    const taxMapsDialog_closeHandler = () => {
        setopenAddBoxDialog(false);
    };

    const getAddBoxButton = () => (
        <IconButton
            variant="contained"
            onClick={AddButtonClick}
            size="small"
            style={{ float: "right", zIndex: 1, marginTop: 10, display: 'block' }}
            disabled={isButtonDisabled}
        >
            <Tooltip key={1} title={'add'}><AddBoxIcon key={2} /></Tooltip>
        </IconButton>
    );

    const info = {
        taxTypeCode: selectedTaxTypeCode,
        inProgress: props.inProgress
    };

    return (
        <div>
            <h1>Customer Resource Mapping</h1>
            <div className="form-group">
                <h6>Customer : {lastUpdated}</h6>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}> {/* Flex container */}
                    <h5 style={{ margin: 0 }}>Media Type :</h5> {/* Inline Label */}
                    <select className="form-control" style={{ width: '200px' }}>
                        <option value="type1">Media Type 1</option>
                        <option value="type2">Media Type 2</option>
                        <option value="type3">Media Type 3</option>
                        <option value="type4">Media Type 4</option>
                    </select>
                </div>
                
                {/*<select className="form-control">*/}
                {/*    {mediaTypes.map((type, index) => (*/}
                {/*        <option key={index} value={type}>*/}
                {/*            {type}*/}
                {/*        </option>*/}
                {/*    ))}*/}
                {/*</select>*/}
                <div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
                    <EnhancedDataGrid
                        rows={data}
                        disableColumnMenu
                        pagination
                        pageSize={10}
                        editMode="row"
                        processRowUpdate={processRowUpdate}
                        onProcessRowUpdateError={(err) => { }}
                        title={"Customer Resources"}
                        disableSelectionOnClick
                        customcomponent={<>{getAddBoxButton()}</>}
                        rowModesModel={rowModesModel}
                        columns={[
                            {
                                headerName: 'Resource Code',
                                field: 'taxCode',
                                flex: 0.5,
                                cellClassName: "MuiInputBase-input MuiInput-input",
                                editable: isAdding,
                            },
                            {
                                headerName: 'Resource Name',
                                field: 'taxDesc',
                                flex: 1,
                                editable: true,
                                cellClassName: "MuiInputBase-input MuiInput-input",
                            },
                            {
                                headerName: 'Active',
                                field: '', // Assuming this is the "Active" field
                                flex: 0.5,
                                editable: true,
                                renderCell: (params) => (
                                    <Checkbox
                                        color="default"
                                        checked={params.value}
                                        onChange={(e) => {
                                            const newValue = e.target.checked;
                                            params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue });
                                        }}
                                    />
                                ),
                            },
                            {
                                headerName: 'User Group',
                                field: 'rolesData',
                                flex: 1,
                                editable: false,
                                renderEditCell: (props) => {
                                    const { userRolesList } = props.row;
                                    return (
                                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                            <Tooltip title={getUserRoleNameList(userRolesList)}>
                                                <Typography sx={{ pt: '10px' }} variant="inherit">
                                                    {getUserRoleName(userRolesList)}
                                                </Typography>
                                            </Tooltip>
                                            {/* You can replace UserRolesResources with appropriate component */}
                                            {/* <UserRolesResources info={info} onClose={selectedUserRoles_onClose} /> */}
                                        </Box>
                                    );
                                },
                            },

                            {
                                field: 'actions',
                                type: 'actions',
                                headerName: 'Actions',
                                width: 120,
                                cellClassName: 'actions',
                                getActions: (rowData) => {
                                    const isInEditMode = rowModesModel[rowData.id]?.mode === GridRowModes.Edit;
                                    if (isInEditMode) {
                                        return [
                                            <GridActionsCellItem
                                                key={rowData.id + 1}
                                                icon={<Tooltip key={rowData.id + 2} title={'Save'}><DoneIcon key={rowData.id + 1} /></Tooltip>}
                                                label="Save"
                                                color="inherit"
                                                onClick={() => { handleSaveClick(rowData.row) }}
                                            />,
                                            <GridActionsCellItem
                                                key={rowData.id + 2}
                                                icon={<Tooltip key={rowData.id + 2} title={'Cancel'}><CancelIcon key={rowData.id + 1} /></Tooltip>}
                                                label="Cancel"
                                                className="textPrimary"
                                                onClick={() => { handleCancelClick(rowData.id) }}
                                                color="inherit"
                                            />,
                                        ];
                                    }
                                    return [
                                        <GridActionsCellItem
                                            key={rowData.id + 3}
                                            icon={<Tooltip key={rowData.id + 2} title={'Delete'}><DeleteIcon key={rowData.id + 1} /></Tooltip>}
                                            label="Delete"
                                            onClick={() => { handleDeleteClick(rowData.row) }}
                                            color="inherit"
                                            disabled={isButtonDisabled}
                                        />,
                                    ];
                                }
                            }
                        ]}
                        getRowId={(row) => row.rowId}
                        editable={
                            {
                                onRowAdd: newData =>
                                    new Promise((resolve, reject) => {
                                        newData.rowId = 0;
                                        newData.companyCode = parseInt(state.companyCode);

                                        if (isRecordValid(newData)) {
                                            saveTaxes(newData, resolve, reject);
                                        }
                                        else {
                                            reject();
                                        }
                                    }),
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve, reject) => {

                                        if (isRecordValid(newData)) {
                                            saveTaxes(newData, resolve, reject);
                                        }
                                        else {
                                            reject();
                                        }
                                    }),
                                onRowDelete: oldData =>
                                    new Promise((resolve, reject) => {
                                        deleteTaxes(oldData, resolve, reject);
                                    }),
                                onRowAddCancelled: rowData =>
                                    new Promise((resolve, reject) => {
                                    }),
                                onRowUpdateCancelled: rowData =>
                                    new Promise((resolve, reject) => {
                                    })
                            }
                        }
                    />
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button variant="contained" color="primary" style={{ marginRight: '10px' }}>
                        Save
                    </Button>
                    <Button variant="outlined" color="secondary">
                        Reset
                    </Button>
                </div>
            </div>
            <Dialog open={openAddBoxDialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
                <DialogContent>
                    <AddResources info={info} onClose={taxMapsDialog_closeHandler} />
                </DialogContent>
            </Dialog>

            <Dialog
                open={openDeleteConfirmation}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Delete Record
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the tax code "{deleteRowData ? deleteRowData.taxCode : ""}" ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={deleteTaxes} color="primary">
                        Yes
                    </Button>
                    <Button autoFocus onClick={closeDeleteDialog} color="primary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}